"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThousandsNotation = exports.MillionsNotation = exports.BillionsNotation = void 0;
exports.BillionsNotation = {
    default: "B",
    "en-US": "B",
};
exports.MillionsNotation = {
    default: "M",
    "en-US": "M",
};
exports.ThousandsNotation = {
    default: "K",
    "en-US": "K",
};
